import ReactIcon from '@ant-design/icons-react';
export function setTwoToneColor(primaryColor, secondaryColor) {
    if (primaryColor && !secondaryColor) {
        return ReactIcon.setTwoToneColors({
            primaryColor,
        });
    }
    return ReactIcon.setTwoToneColors({
        primaryColor: primaryColor || 'var(--ant-primary-color)',
        secondaryColor: secondaryColor || 'var(--ant-primary-1)'
    });
}
export function getTwoToneColor() {
    const colors = ReactIcon.getTwoToneColors();
    return colors.primaryColor;
}
